import { render, staticRenderFns } from "./GroupCoverageRow.vue?vue&type=template&id=4a672cf0&"
import script from "./GroupCoverageRow.vue?vue&type=script&lang=js&"
export * from "./GroupCoverageRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports